import * as React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tabs } from "@jhool-io/fe-components";
import NoteList from "../NoteList/NoteList";
import SuperviseeNoteList from "../SuperviseeNoteList/SuperviseeNoteList";
import { UserPermisions, UserRole } from "../../../../utils/types/user";
import Navbar from "../../../Navbar/Navbar";
import { useAppSelector } from "../../../../hooks/useRedux";

export default function NoteListWrapper() {
    const [totalNotesCount, setTotalNotesCount] = React.useState("");
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const { practice } = useAppSelector((state) => state.userPractice);

    const activeTabInLocalStorage = localStorage.getItem("activeBtn");

    const notesFiltersFromLocalStorage =
        localStorage.getItem("notelist_filters");

    let activeTab;

    const handleChangeTab = (tab: string) => {
        localStorage.setItem("activeBtn", tab);
        searchParams.set("tab", tab);
        localStorage.setItem("notelist_filters", searchParams.toString());
        if (tab === "my_supervisees_notes") {
            navigate(`/notes?tab=${tab}`);
        } else {
            let filtersString = "";
            if (notesFiltersFromLocalStorage) {
                const filtersParams = new URLSearchParams(
                    notesFiltersFromLocalStorage
                );
                filtersParams.delete("tab");
                filtersString = filtersParams.toString();
            }
            navigate(
                `/notes?tab=${tab}${filtersString ? `&${filtersString}` : ""}`
            );
        }
    };

    const canViewAllNotes =
        practice?.permissions?.includes(
            UserPermisions.CLIENT_INFO_NOTES_FLAG_FOR_AUDIT_WRITE
        ) ||
        practice?.roles?.includes(UserRole.AUDITOR_ADMIN) ||
        practice?.is_supervisor;

    const tabItems = [
        {
            key: "my_notes",
            label: "My notes",
            onClick: () => handleChangeTab("my_notes"),
            children: <NoteList setNotesCount={setTotalNotesCount} />,
            hide: !practice?.provider_id,
        },
        {
            key: "my_supervisees_notes",
            label: "Supervisees' notes",
            onClick: () => handleChangeTab("my_supervisees_notes"),
            hide: !practice?.is_supervisor,
            children: <SuperviseeNoteList setNotesCount={setTotalNotesCount} />,
        },
        {
            key: "all_notes",
            label: "All notes",
            onClick: () => handleChangeTab("all_notes"),
            hide: !canViewAllNotes,
            children: <NoteList viewAll setNotesCount={setTotalNotesCount} />,
        },
    ];

    const tabItemsToNotHide = tabItems.filter((item) => !item.hide);

    if (tabItemsToNotHide.length < 2) {
        activeTab = null;
    } else {
        const tabInLS =
            activeTabInLocalStorage &&
            tabItems.find(
                (tab) => !tab.hide && tab.key === activeTabInLocalStorage
            )?.key;

        activeTab =
            searchParams.get("tab") ||
            tabInLS ||
            (practice?.provider_id ? "my_notes" : "all_notes");
    }

    return (
        <>
            <Navbar
                title={`Notes${totalNotesCount ? `(${totalNotesCount})` : ""}`}
            />
            <div className="page">
                {activeTab ? (
                    <Tabs
                        items={tabItems}
                        size="medium"
                        className="w-full rounded-b-none"
                        defaultActiveKey={activeTab}
                    />
                ) : (
                    <NoteList
                        viewAll={
                            practice?.permissions?.includes(
                                UserPermisions.CLIENT_INFO_NOTES_FLAG_FOR_AUDIT_WRITE
                            ) ||
                            practice?.roles?.includes(UserRole.AUDITOR_ADMIN)
                        }
                        setNotesCount={setTotalNotesCount}
                    />
                )}
            </div>
        </>
    );
}
